import { Route, Routes, useLocation } from "react-router-dom";
import {
	HistoryPage,
	IFrame,
	LessonPage,
	MainPage,
	MyDayPage,
	MyStatisticsPage,
	MySubscriptionsPage,
	NotFoundPage,
	OrderFailPage,
	OrderPages,
	OrderSuccessPage,
	PaymentSuccessPage,
	PricingActualPage,
	PricingPage,
	PrivacyPolicyPage,
	ProfilePage,
	RemPage,
	ServicePage,
	SignPage,
	SubscriptionsPlansPage,
	TheTeamPage,
	TutorialsPage,
	UserAgreementPage,
} from "./pages";
import { BaseLayout, CabinetLayout, SignInForm, SignUpForm } from "./components";
import { observer } from "mobx-react";
import { GrandChartBasic, ProtectedRoute } from "./components/common";
import { useStores } from "./stores";
import { useEffect } from "react";
import { ContactPage } from "./pages/ContactPage/ContactPage";
import { TestIFramePage } from "./pages/TestIFramePage/TestIFramePage";
import { gtmEvent } from "./helpers";
import { VerifyEmailPage } from "./pages/VerifyEmail/VerifyEmail";
import { NotificationsPage } from "./pages/NotificationsPage";
import { useTranslation } from "react-i18next";
import { API } from "./core";
import { ForgotForm } from "./components/ui/Forms/ForgotForm/ForgotForm";
import { GrandChartGroupRoute } from "./components/common/GrandChartBasic";

const App = observer(() => {
	const { authStore, settingsStore, countryStore } = useStores();
	const location = useLocation();

	const { i18n } = useTranslation();

	// Подписываемся на изменение языка
	useEffect(() => {
		(async () => {
			// Сохраняем в localStorage
			API.saveLanguage = settingsStore.language;
			// Меняем в системе
			await i18n.changeLanguage(settingsStore.language.toLowerCase());
		})();
	}, [settingsStore.language]);

	useEffect(() => {
		(async () => {
			// Получение страны пользователя
			// await countryStore.getCountry();

			console.warn("Разблокировать определение страны");

			await authStore.check();
		})();
	}, []);

	useEffect(() => {
		if (!location.pathname) return;

		// если пришли после закрытия grand chart — не скролим
		if (location.state?.fromGrandChartClose) {
			return;
		}

		// игнорируем grand-chart
		if (location.pathname.includes("/grand-chart/")) {
			return;
		}

		// TODO Разкомментировать
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	}, [location.pathname]);

	useEffect(() => {
		if (authStore.isAuth) {
			gtmEvent({ event: "User_ID", user_id: authStore.userStore.id });
		}
	}, [location.pathname]);

	return (
		<Routes>

			<Route index element={<MainPage />} />
			<Route path={"/"} element={<BaseLayout />}>
				<Route path={"verify/:id/:hash"} element={<VerifyEmailPage />} />
				<Route path={"sign"} element={<SignPage />}>
					<Route index element={<SignUpForm />} />
					<Route path={"login"} element={<SignInForm />} />
					<Route path={"forgot-password"} element={<ForgotForm />} />
				</Route>
				<Route path={"the-team"} element={<TheTeamPage />} />
				<Route path={"user-agreement"} element={<UserAgreementPage />} />
				<Route path={"privacy-policy"} element={<PrivacyPolicyPage />} />
				<Route path={"pricing-old"} element={<PricingPage />} />
				<Route path={"pricing"} element={<PricingActualPage />} />
				<Route path={"contact"} element={<ContactPage />} />
				<Route path={":service/:instrument"} element={<ServicePage />} />
				<Route path={"cabinet"} element={<ProtectedRoute />}>
					<Route element={<CabinetLayout />}>
						<Route path={"my-day"} element={<MyDayPage />} />
						<Route path={"my-statistics"} element={<MyStatisticsPage />} />
						<Route path={"my-statistics/history/:date"} element={<HistoryPage />} />
						<Route path={"my-subscriptions"} element={<MySubscriptionsPage />}>
							<Route path={"grand-chart/:id"} element={<GrandChartBasic />}>
								<Route path={"course/:courseId/module/:moduleId/group/:groupId"} element={<GrandChartGroupRoute />} />
							</Route>
						</Route>
						<Route path={"subscriptions-plans"} element={<SubscriptionsPlansPage />} />
						<Route path={"tutorials"} element={<TutorialsPage />} />
						<Route path={"profile"} element={<ProfilePage />} />
						<Route path={"rem"} element={<RemPage />} />
						<Route path={"notifications"} element={<NotificationsPage />} />

						<Route path={"order"} element={<OrderPages />}>
							<Route path={"success"} element={<OrderSuccessPage />} />
							<Route path={"fail"} element={<OrderFailPage />} />
						</Route>
					</Route>

					<Route path={"payment/success"} element={<PaymentSuccessPage />} />
					<Route path={"lessons/:uuid"} element={<LessonPage />}>
						<Route path={"grand-chart/:id"} element={<GrandChartBasic />}>
							<Route path={"course/:courseId/module/:moduleId/group/:groupId"} element={<GrandChartGroupRoute />} />
						</Route>
					</Route>
				</Route>

				<Route path={"*"} element={<NotFoundPage />} />
			</Route>

			<Route path={"iframe"} element={<IFrame />} />
			<Route path={"test-iframe"} element={<TestIFramePage />} />
		</Routes>
	);
});

export default App;
